class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');

      document.dispatchEvent(new CustomEvent('quickview:close'));
      const trigger = this.triggerButton;
      requestAnimationFrame(() => {
        if (trigger?.isConnected) trigger.focus({preventScroll: true});
      });
    });
  }
}
customElements.define('quick-view-drawer', QuickViewDrawer);

class QuickViewButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      const wrapper = this.closest('.card-wrapper');
      const drawer = wrapper?.querySelector('quick-view-drawer');
      if (drawer) {
        drawer.triggerButton = event.target.closest('button') || this;
        drawer.querySelector('summary').click();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      }
      else if (this.dataset.productUrl) {
        window.location.href = this.dataset.productUrl;
      }
    });
  }
}
customElements.define('quick-view-button', QuickViewButton);

class QuickView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this));
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.controller?.abort();
  }

  async handleIntersection(entries) {
    if (!entries[0].isIntersecting || this.loading) return;
    const drawerContent = this.querySelector('.quick-view__content');
    if (!drawerContent || drawerContent.childElementCount) return;
    drawerContent.style.removeProperty('padding');
    this.loading = true;
    this.controller = new AbortController();
    const timeout = setTimeout(() => this.controller.abort(), 15000);
    const productUrl = this.dataset.productUrl.split('?')[0];
    try {
      const response = await fetch(`${productUrl}?view=modal`, {signal: this.controller.signal});
      if (!response.ok) throw new Error('Quick view unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const productElement = html.querySelector('.quick-view__content');
      if (!productElement || !productElement.innerHTML.trim()) throw new Error('Quick view unavailable');
      if (!this.isConnected) return;
      this.setInnerHTML(drawerContent, productElement.innerHTML);
      window.Shopify?.PaymentButton?.init();
      document.dispatchEvent(new CustomEvent('quickview:loaded', {detail: {productUrl: this.dataset.productUrl}}));
    } catch (_) {
      if (!this.isConnected) return;
      const message = document.createElement('p');
      message.setAttribute('role', 'status');
      message.textContent = 'Open the product page to choose your options.';
      const link = document.createElement('a');
      link.className = 'button';
      link.href = productUrl;
      link.textContent = 'View product';
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'button button--secondary';
      close.textContent = 'Close';
      close.style.marginInlineStart = '12px';
      close.addEventListener('click', () => this.closest('quick-view-drawer').dispatchEvent(new CustomEvent('drawer:force-close')));
      drawerContent.replaceChildren(message, link, close);
      requestAnimationFrame(() => { if (this.closest('details')?.open) link.focus(); });
      drawerContent.style.padding = '32px';
    } finally {
      clearTimeout(timeout);
      this.loading = false;
      drawerContent.classList.add('hide-cover');
    }
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
customElements.define('quick-view', QuickView);
